/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-25 11:09:25
 */
import LoginForm from "../components/LoginForm";
import { Link, useNavigate } from "react-router-dom";
import "../index.less";
import Brand from "@/components/brand/brand";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { HOME_URL } from "@/config/config";

const Login = () => {
	const navigate = useNavigate();

	const { token } = useSelector((state: any) => state.global);
	const nickName = localStorage.getItem("nickname");
	useEffect(() => {
		if (token && nickName) {
			navigate(HOME_URL);
		}
	}, []);

	return (
		<div className="login-container">
			<Brand logoSize={"3rem"} fontSize={"2.5rem"} />
			<div className="bottom">
				<div className="login-box">
					<div className="login-form">
						<div className="logo-text">Log in</div>
						<LoginForm />
						<div className="login-bottom">
							<span className="login-form-text">
								<a onClick={() => navigate("/emailValidate")} style={{ color: "#565BDD" }}>
									Forgot password？
								</a>
							</span>
							<span className="login-form-text">
								New to AdSurgebot?
								<Link className="linkStyle" to="/register" style={{ color: "#565BDD", marginLeft: "0.5rem" }}>
									Sign up!
								</Link>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
